import axios from 'axios'
import jwtDefaultConfig from './jwtDefaultConfig'
import toast from 'react-hot-toast'
import { clearUserSession, getToken } from '../../../services/token'

const authClient = axios.create()
let interceptorsInstalled = false
let redirectingForExpiredSession = false

const isApiRequest = config => String(config?.url || '').startsWith(jwtDefaultConfig.apiVendasEndpoint)

export default class JwtService {
  jwtConfig = { ...jwtDefaultConfig }

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    if (interceptorsInstalled) return
    interceptorsInstalled = true

    // The API is the source of truth for token expiration and returns the 401.
    axios.interceptors.request.use(
      config => {
        if (!isApiRequest(config)) return config

        const accessToken = this.getToken()
        if (accessToken) {
          config.headers = config.headers || {}
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
          config.__hasUserSession = true
        }
        return config
      },
      error => Promise.reject(error)
    )

    axios.interceptors.response.use(
      response => {
        const { data } = response
        if (data?.success === false && Array.isArray(data.notifications) && data.notifications.length > 0) {
          try {
            const errorMessage = data.notifications.map(item => `${item.property}: ${item.message}`).join('\n')
            toast.error(errorMessage, {
              position: 'top-center',
              style: { borderRadius: '10px', background: '#ea5455', color: '#fff' }
            })
          } catch {
            // Response notifications must not interrupt the request flow.
          }
        }
        return response
      },
      error => {
        const { config, response } = error

        if (response?.status === 500) {
          toast.error('Um erro inesperado aconteceu, tente novamente em alguns segundos.', {
            position: 'top-center',
            style: { borderRadius: '10px', background: '#ea5455', color: '#fff' }
          })
        }

        if (response?.status === 401 && config?.__hasUserSession) {
          this._clearSessionAndRedirect()
        }
        return Promise.reject(error)
      }
    )
  }

  _clearSessionAndRedirect() {
    if (redirectingForExpiredSession) return
    redirectingForExpiredSession = true
    clearUserSession()
    window.location.replace('/?login=1')
  }

  getToken() {
    return getToken()
  }

  getRefreshToken() {
    return null
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken() {
    // There is no refresh token flow for the portal JWT.
  }

  login(args) {
    return authClient.post(this.jwtConfig.loginEndpoint, { ...args, token: this.jwtConfig.loginToken })
  }

  register(...args) {
    return authClient.post(this.jwtConfig.registerEndpoint, ...args)
  }

  post(url, data) {
    return axios.post(this.jwtConfig.apiVendasEndpoint + url, { ...data })
  }

  get(url) {
    return axios.get(this.jwtConfig.apiVendasEndpoint + url)
  }
}